import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "wheelchair"
const WheelchairIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M18 1.125C19.657 1.125 21 2.468 21 4.125S19.657 7.125 18 7.125Q17.88 7.125 17.761 7.115C18.197 7.529 18.303 8.203 17.981 8.739L16.539 11.142 19.669 11.925C21.099 12.283 21.805 13.9 21.094 15.193L18.067 20.695C17.837 21.115 17.396 21.375 16.917 21.375H15.763C14.879 21.375 14.247 20.52 14.507 19.677L15.533 16.343 14.623 16.184 14.625 16.124C14.625 15.61 14.563 15.111 14.448 14.632L16 14.902C16.778 15.037 17.26 15.825 17.029 16.58L16.016 19.875H16.806L19.78 14.47C20.017 14.039 19.782 13.5 19.304 13.38L15.684 12.476C14.951 12.292 14.604 11.453 14.992 10.805L16.598 8.127 10.893 4.639 7.125 7.151V7.96L10.416 6.862C10.747 6.752 11.108 6.778 11.419 6.933L12.089 7.268C12.835 7.64 13.048 8.609 12.527 9.26L11.47 10.583 11.45 10.61Q10.785 10.224 10.035 10.004L10.269 9.684 10.279 9.672 10.289 9.658 11.21 8.506 10.818 8.309 7.6 9.382C6.628 9.706 5.625 8.983 5.625 7.96V7.151C5.625 6.65 5.875 6.181 6.293 5.903L10.16 3.325 10.242 3.275C10.654 3.042 11.164 3.048 11.572 3.297L15.413 5.644C15.151 5.198 15 4.679 15 4.125 15 2.468 16.343 1.125 18 1.125M18 2.625C17.172 2.625 16.5 3.297 16.5 4.125S17.172 5.625 18 5.625 19.5 4.953 19.5 4.125 18.828 2.625 18 2.625"
            clipRule="evenodd"
          />
          <path d="M8.25 13.875C9.493 13.875 10.5 14.882 10.5 16.125S9.493 18.375 8.25 18.375 6 17.368 6 16.125 7.007 13.875 8.25 13.875" />
          <path
            fillRule="evenodd"
            d="M8.25 10.875Q8.799 10.875 9.316 10.983C9.838 11.091 10.331 11.276 10.783 11.525 11.91 12.147 12.783 13.172 13.21 14.405 13.383 14.903 13.482 15.435 13.496 15.989Q13.5 16.057 13.5 16.124C13.5 19.024 11.15 21.374 8.25 21.374S3 19.024 3 16.124 5.35 10.875 8.25 10.875M8.25 12.375C6.179 12.375 4.5 14.054 4.5 16.125S6.179 19.875 8.25 19.875Q8.445 19.875 8.633 19.856 8.822 19.836 9.006 19.799 9.373 19.723 9.71 19.58 9.962 19.473 10.195 19.332C10.71 19.02 11.145 18.585 11.457 18.07Q11.551 17.915 11.63 17.75C11.867 17.259 12 16.708 12 16.125 12 14.743 11.253 13.537 10.14 12.886L10.134 12.883 10.099 12.863 10.088 12.856 9.92 12.766 9.89 12.753 9.888 12.75Q9.711 12.665 9.527 12.598L9.496 12.588Q9.134 12.46 8.74 12.407L8.714 12.404Q8.626 12.394 8.539 12.387L8.503 12.384Q8.41 12.378 8.314 12.377H8.31z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default WheelchairIcon
